import { ValuationApproachModel } from 'api';
import { HandleVolatilitySourceParams } from 'pages/ValuationsAllocation/allocation/EquityAllocation/config/customParser/utils/handleVolatilitySource/types';
import { ALLOCATION_SCENARIO_METHOD_OPM } from 'pages/ValuationsAllocation/common/constants/allocation';
import { EQUITY_ALLOCATION_SPREADSHEET_VOLATILITY_SOURCE } from 'pages/ValuationsAllocation/common/constants/equityAllocation/sheetAliases';
import { VALUATIONS_PUBLIC_COMPANIES_APPROACH } from 'pages/ValuationsAllocation/common/constants/valuations';
import { getDefaultCompsApproachForDropdown } from 'pages/ValuationsAllocation/util/getDefaultCompsApproachForDropdown';

const handleVolatilitySource = (params: HandleVolatilitySourceParams) => {
  const { cell, volatilityCell, scenarioMethod, approaches, column } = params;

  const columnValue = column?.value;
  const columnScenarioId = column?.scenarioId;

  const defaultCompsApproach = getDefaultCompsApproachForDropdown(
    approaches as ValuationApproachModel[],
    [VALUATIONS_PUBLIC_COMPANIES_APPROACH],
  );

  const getVolatilitySourceValue = () => {
    // The scenario has a volatility source set from a public comps approach.
    // The columnValue is the id from the valuations_approach_gpc object.
    if (columnValue && columnValue !== 0) {
      return columnValue;
    }

    // Volatility source from an unsaved public comps approach for a new scenario
    const { panel_id: panelId } = defaultCompsApproach || {};
    if (panelId && !columnScenarioId) {
      return panelId;
    }

    // Specified volatility for an existing scenario
    if (!cell.value && columnScenarioId) {
      return null;
    }

    return null;
  };

  const setGridTypeBasedOnValue = (value: number | string | null): 'number' | 'string' | null => {
    if (value === null) {
      return null;
    }
    if (typeof value === 'number') {
      return 'number';
    }
    return 'string';
  };

  if (scenarioMethod !== ALLOCATION_SCENARIO_METHOD_OPM) {
    cell.expr = '';
    cell.value = '';
    cell.dataEditor = null;
    cell.valueViewer = null;
    cell.readOnly = true;
    cell.isRequired = false;
    return;
  }

  if (cell.alias === EQUITY_ALLOCATION_SPREADSHEET_VOLATILITY_SOURCE) {
    if (volatilityCell) {
      const volatilitySourceValue = getVolatilitySourceValue();
      cell.value = volatilitySourceValue;
      cell.gridType = setGridTypeBasedOnValue(volatilitySourceValue as number | string | null);
      volatilityCell.readOnly = volatilitySourceValue !== null;
      volatilityCell.hidden = false;
      volatilityCell.isRequired = true;
    }
  }
};

export default handleVolatilitySource;
